import React from 'react';
import { Button } from '../ui/Button';
export function FinalCTASection() {
  return <section id="cta" className="py-24 bg-slate-900 relative overflow-hidden" data-id="element-84">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-85"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-86"></div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-87">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight" data-id="element-88">
          Ready to Stop Leaving Money on the Table?
        </h2>
        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-89">
          If you have a proven offer and an audience, but your sales don't
          reflect your potential, let's fix that.
        </p>

        <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 mb-10 inline-block text-left max-w-lg w-full" data-id="element-90">
          <h3 className="text-white font-semibold mb-4 text-center" data-id="element-91">
            Who this is for:
          </h3>
          <ul className="space-y-3" data-id="element-92">
            <li className="flex items-start text-slate-300" data-id="element-93">
              <span className="text-emerald-400 mr-2" data-id="element-94">✓</span>
              Coaches & Course Creators ready to upscale
            </li>
            <li className="flex items-start text-slate-300" data-id="element-95">
              <span className="text-emerald-400 mr-2" data-id="element-96">✓</span>
              Business owners ready to invest in superior positioning
            </li>
            <li className="flex items-start text-slate-300" data-id="element-97">
              <span className="text-emerald-400 mr-2" data-id="element-98">✓</span>
              Creators who want to scale without being "salesy"
            </li>
          </ul>
        </div>

        <div className="flex flex-col items-center" data-id="element-99">
          <Button size="lg" variant="secondary" className="w-full sm:w-auto text-lg px-12 py-4" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).Calendly) {
            ;
            (window as any).Calendly.initPopupWidget({
              url: 'https://calendly.com/okechcopy/new-meeting'
            });
          }
        }} data-id="element-100">
            Book Your Strategy Call
          </Button>
          <p className="mt-4 text-sm text-slate-500" data-id="element-101">
            Only 3 strategy spots left for Q2
          </p>
        </div>
      </div>
    </section>;
}